// import akon from '../../Images/collaborators/akon.jpeg';
import charlie from '../../Images/collaborators/charlie.jpeg';
import johnny_manuel from '../../Images/collaborators/johnny_manuel.jpeg';
import like_mike from '../../Images/collaborators/like_mike.jpeg';
import steve_void from '../../Images/collaborators/steve_void.jpeg';
import naomi_pilgrim from '../../Images/collaborators/naomi_pilgrim.jpeg';
import zach_rogue from '../../Images/collaborators/zach_rogue.png';
import warner_music from '../../Images/collaborators/warner_music.png';
import universal_music from '../../Images/collaborators/universal_music.png';
import sony_music from '../../Images/collaborators/sony_music.png';
import rock_mafia from '../../Images/collaborators/rock_mafia.jpeg';
import bleeding_fingers from '../../Images/collaborators/bleeding_fingers.jpeg';
import atlantic from '../../Images/collaborators/atlantic.png';
import mike_caren from '../../Images/collaborators/mike_caren.jpeg';
import extreme_music from '../../Images/collaborators/extreme_music.jpeg';
import riptide_music from '../../Images/collaborators/riptide_music.png';
import flo_roda from '../../Images/collaborators/flo_rida.png';

const CollaboratorsData = [
	{
		name: 'Charlie Puth',
		thumbnail: charlie,
	},
	{
		name: 'Steve Void',
		thumbnail: steve_void,
	},
	{
		name: 'Dimitri Vegas & Like Mike',
		thumbnail: like_mike,
	},
	{
		name: 'Flo Rida',
		thumbnail: flo_roda,
	},
	// {
	// 	name: 'Akon',
	// 	thumbnail: akon,
	// },
	{
		name: 'Johnny Manuel',
		thumbnail: johnny_manuel,
	},
	{
		name: 'Naomi Pilgrim',
		thumbnail: naomi_pilgrim,
	},
	{
		name: 'Zach Rogue',
		thumbnail: zach_rogue,
	},
	{
		name: 'Mike Caren',
		thumbnail: mike_caren,
	},
	{
		name: 'Warner Music Group',
		thumbnail: warner_music,
	},
	{
		name: 'Bleeding Fingers',
		thumbnail: bleeding_fingers,
	},
	{
		name: 'Universal Music Group',
		thumbnail: universal_music,
	},
	{
		name: 'Rock Mafia',
		thumbnail: rock_mafia,
	},
	{
		name: 'Atlantic Records',
		thumbnail: atlantic,
	},
	{
		name: 'Sony Music Publishing',
		thumbnail: sony_music,
	},
	{
		name: 'Extreme Music',
		thumbnail: extreme_music,
	},
	{
		name: 'Riptide Music Group',
		thumbnail: riptide_music,
	},
];

export default CollaboratorsData;